export default "__VITE_ASSET__CVhjPsr$__"